import { render, staticRenderFns } from "./FinalizeModal.vue?vue&type=template&id=1b833848&scoped=true&"
import script from "./FinalizeModal.vue?vue&type=script&lang=js&"
export * from "./FinalizeModal.vue?vue&type=script&lang=js&"
import style0 from "./FinalizeModal.vue?vue&type=style&index=0&id=1b833848&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b833848",
  null
  
)

export default component.exports